export const shareMixin = {
  data() {
    return {
      setDeepLinkPath: (param) => {
        window.history.replaceState(null, '', `?deepLink=${param}`);
      },
    };
  },
  methods: {
    updateShareUrl(param) {
      this.setDeepLinkPath(param);
    },
    updateShareableUrl(component = null, data = null) {
      if (!component) {
        window.history.replaceState(null, '', window.location.pathname);
      } else {
        switch (component) {
          case 'Recipes':
            this.updateShareUrl('all-recipes');
            break;
          case 'RecipeDetail':
          case 'RecipeDetailPublic':
            if (data && data.id) {
              this.updateShareUrl(`all-recipes/r/${data.id}`);
            }
            break;
          case 'Plans':
            this.updateShareUrl('plans');
            break;
          case 'PlanDetail':
          case 'PlanDetailPublic':
            if (data && data.id) {
              this.updateShareUrl(`plans/${data.id}`);
            }
            break;
        }
      }
    },
  },
};
